export default "__VITE_ASSET__Dpxjs5vm__"